import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/expenses";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getExpensesListSaga({ payload }) {
  try {
    const response = yield call(apis.getExpensesList, payload);
    yield put(
      actions.getExpensesResponse({
        list: response.data.expenses,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getExpensesRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addExpenseSaga({ payload }) {
  try {
    // Extract metadata from payload (they're only needed for refresh calls, not for the API)
    const { expenseData, after_date, before_date, page } = payload;

    // Call addExpense with clean expense data only
    yield call(apis.addExpense, expenseData);
    yield showSuccessMsg("addedSuccessfully");
    // Refresh the expenses list
    yield put(
      actions.getExpensesRequest({
        items: 10,
        page: page || 1,
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );
    yield put(
      actions.getMimarProfitRequest({
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editExpenseSaga({ payload }) {
  try {
    // Extract metadata from payload (they're only needed for refresh calls, not for the API)
    const { id, expenseData, after_date, before_date, page } = payload;

    // Call editExpense with clean expense data only
    yield call(apis.editExpense, {
      id,
      data: expenseData,
    });
    yield showSuccessMsg("editedSuccessfully");
    // Refresh the expenses list
    yield put(
      actions.getExpensesRequest({
        items: 10,
        page: page || 1,
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );

    yield put(
      actions.getMimarProfitRequest({
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getExpenseDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.viewExpense, payload);
    yield put(
      actions.getExpenseResponse({
        expenseDetails: response.data.expense,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteExpenseSaga({ payload }) {
  try {
    // Extract date filters and other fields from payload (they're only needed for refresh calls, not for the API)
    const { after_date, before_date, currentPage, id } = payload;

    // Call deleteExpense with only the id
    yield call(apis.deleteExpense, { id });
    yield showSuccessMsg("deletedSuccessfully");
    yield put(
      actions.getExpensesRequest({
        items: 10,
        page: currentPage || 1,
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );
    yield put(
      actions.getMimarProfitRequest({
        after_date: after_date || null,
        before_date: before_date || null,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getMimarProfitSaga({ payload }) {
  try {
    const response = yield call(apis.getMimarProfit, payload);
    yield put(
      actions.getMimarProfitResponse({
        mimarProfit: response.data.financial_statistics,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* ExpensesSagas() {
  yield takeEvery(types.GET_EXPENSES_REQUEST, getExpensesListSaga);
  yield takeEvery(types.ADD_EXPENSE_REQUEST, addExpenseSaga);
  yield takeEvery(types.GET_EXPENSE_DETAILS_REQUEST, getExpenseDetailsSaga);
  yield takeEvery(types.EDIT_EXPENSE_REQUEST, editExpenseSaga);
  yield takeEvery(types.DELETE_EXPENSE_REQUEST, deleteExpenseSaga);
  yield takeEvery(types.GET_MIMAR_PROFIT_REQUEST, getMimarProfitSaga);
}
